import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ChargeHelper from 'features/Charge/chargeHelper';
import _ from 'lodash';
import ToastHelper from 'general/helpers/ToastHelper';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';

DialogReportErrorChargePointView.propTypes = {
  item: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogReportErrorChargePointView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState('');
  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    if (!Utils.isValid(reason)) {
      ToastHelper.showError('Vui lòng nhập lý do báo lỗi tủ pin');
      return;
    }
    const payload = { description: reason.trim() };
    setLoading(true);
    const result = await ChargeHelper.API.requestReportCabinetError(item?.pointId, payload);
    if (result?.result === 'success' || result === true) {
      ToastHelper.showSuccess('Báo lỗi tủ pin thành công');
      if (onDone) onDone();
    } else {
      ToastHelper.showError(_.isString(result) ? result : result?.reason || 'Báo lỗi tủ pin thất bại');
    }
    setLoading(false);
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3 gap-2">
        <div className="mb-4">
          <img src={AppResource.vng.vngErrorCabinPin} />
        </div>

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Báo lỗi tủ pin
        </span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Nhập thông tin lỗi xuống ô bên dưới để báo lỗi này lên hệ thống.
        </span>
      </div>

      <div className="row m-0 p-0 px-3 mt-3">
        <div className="col-12 mb-4 px-0">
          <div>
            {UIHelper.buildFormLabel('Mô tả thông tin lỗi', true)}
            <KTFormTextArea
              placeholder="Nhập mô tả"
              name="reason"
              value={reason}
              onChange={(value) => {
                setReason(value);
              }}
              rows={4}
            />
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center gap-3 p-3 w-100"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildRedButton('Báo lỗi', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogReportErrorChargePointView;
